import { defineComponent as _defineComponent } from 'vue'
import Calendar from "@/components/calendar2.vue"
import { DataInstance, Userspaces, Meetings, InviteLinks } from '@busy-human/opt-library'
import { ref, computed, watch, WritableComputedRef } from 'vue'
import { httpsCallable } from 'firebase/functions';
import { auth, functions } from '@/util/firebase';
import { ISOTimestamp } from '@busy-human/gearbox'
import moment, { Moment } from 'moment';
import { ISOTimeChunk, DayWithMomentChunk } from "./meeting-request-types";
import { useMeetingRequestSchedule } from "./schedule-mixin";

type scrollEl = {
    element: HTMLElement,
    day: string
}

type Props = {
    invite: InviteLinks.Model
    request: Meetings.Model,
    events: ISOTimeChunk[]
}
type Emits = {
    (e: 'update:request', request: Meetings.Model): void
    (e: 'update:selectedDate', date: string | Date): void
    (e: 'previous'): void
    (e: 'progress'): void
    (e: 'update:timesAvailable',timesAvailable: DayWithMomentChunk[]):void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'date-selector',
  props: {
    invite: null,
    request: null,
    events: null
  },
  emits: ["update:request", "update:selectedDate", "previous", "progress", "update:timesAvailable"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'update:request', request: Meetings.Model): void
    (e: 'update:selectedDate', date: string | Date): void
    (e: 'previous'): void
    (e: 'progress'): void
    (e: 'update:timesAvailable',timesAvailable: DayWithMomentChunk[]):void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    invite: InviteLinks.Model
    request: Meetings.Model,
    events: ISOTimeChunk[]
}


const {
    meetingDate,
    meetingLength,
    isDateSelected,
    setStart,
    setEnd,
    blockedDays,
    disabledDays,

} = useMeetingRequestSchedule(null);

const getUserAvailability = httpsCallable<{uid: string, year: number, month: number}, {startTime: string, endTime: string}[]>(functions, 'getUserAvailability')
const setMonth = ref<number>()
const setYear = ref<number>()
const timesAvailable = ref<DayWithMomentChunk[]>([])
const timesAvailableForDay = ref<DayWithMomentChunk[]>([])
const startTime = ref<Moment>()
const startTimeTmp = ref<Moment>()
const endTime = ref<Moment>()
const endTimeTmp = ref<Moment>()
// const disabledDays = ref<string[]>([])
// const blockedDays = ref<string[]>([])

// const loading = ref<boolean>(true)
// 

// console.log("EVENTS", props.events)
// watch(()=> props.events, events=>{
//     if(events){
//         console.log("DateSelector",events)
//     }
// },{immediate:true, deep:true})

const previous = () => {
    emit('previous');
}

const proceed = () => {
    emit('progress');
}

const formatDate = (date: string | Date) =>{
    let tmp = moment(date).format("MMMM DD, YYYY")
    // console.log("formated date:",tmp)
    return tmp
}

const updateSelectedDate = (date: Date | string) =>{
    let newDate = new Date(date)
    // console.log("updated date:", newDate)
    emit("update:selectedDate",newDate)
}
const getAvailability = (value:DayWithMomentChunk[]) =>{
    // console.log("getAvailability was called:",value)
    timesAvailable.value = value;
    //getting values here now!

    // console.log("HERE??",timesAvailable.value)
    // for(let i = 0; i <timesAvailable.value.length; i++){
    //     console.log(timesAvailable.value[i].start.format("h:mma"),timesAvailable.value[i].end.format("h:mma"))
    // }
    emit('update:timesAvailable', timesAvailable.value)
}

const setDisabledDays = (value:string[])=>{
    disabledDays.value = value
}
const setBlockedDays = (value:string[])=>{
    // console.log("WAS CALLED",value)
    let currentTime = moment()
    if(currentTime.isAfter(endTime.value)){
        let blockedDay = currentTime.format("MMMM DD, YYYY")
        blockedDays.value = value;
        blockedDays.value.push(blockedDay)
    }else{
        blockedDays.value = value;
    }
}

const setMeetingLength = (value:number)=>{
    meetingLength.value = value
}

const setEvents = async(value:number)=>{
    // loading.value = true;
    const now = new Date();
    const month = now.getMonth() + value;
    const year = now.getFullYear();
    const result = await getUserAvailability({
        uid: (props.invite.collector || props.invite.payer)!,
        year, month

    })
    // loading.value = false;
}

const selectedMonth = (value:number) =>{
    setMonth.value = value
}

const selectedYear = (value:number) =>{
    setYear.value = value
}



const __returned__ = { props, meetingDate, meetingLength, isDateSelected, setStart, setEnd, blockedDays, disabledDays, emit, getUserAvailability, setMonth, setYear, timesAvailable, timesAvailableForDay, startTime, startTimeTmp, endTime, endTimeTmp, previous, proceed, formatDate, updateSelectedDate, getAvailability, setDisabledDays, setBlockedDays, setMeetingLength, setEvents, selectedMonth, selectedYear, Calendar, DataInstance, Userspaces, Meetings, InviteLinks, ref, computed, watch, WritableComputedRef, httpsCallable, auth, functions, ISOTimestamp, moment, Moment, ISOTimeChunk, DayWithMomentChunk, useMeetingRequestSchedule }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})